import React, {useState} from "react"
import classNames from "classnames"
import {CombinedAssignmentItem} from "../AssignmentNavigator/AssignmentNavigator"
import {AssignmentNavigatorItemsList} from "../AssignmentNavigatorItemsList/AssignmentNavigatorItemsList"
import Icon from "../Icon/Icon"

interface AssignmentNavigatorGroupSectionProps {
	title: string
	assignment: CombinedAssignmentItem[]
	navigatorItemRef: React.RefObject<HTMLLIElement>
}

export function AssignmentNavigatorGroupSection({
	title,
	assignment,
	navigatorItemRef,
}: AssignmentNavigatorGroupSectionProps) {
	const [isOpen, setIsOpen] = useState(true)

	return (
		<div className="assignment-navigator-with-grouping-group-container">
			<div
				className="assignment-navigator-with-grouping-items-title-and-count"
				role="button"
				tabIndex={0}
				aria-expanded={isOpen}
				onClick={() => setIsOpen((prev) => !prev)}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault()
						setIsOpen((prev) => !prev)
					}
				}}
			>
				<span className="assignment-navigator-with-grouping-items-title">{title}</span>({assignment.length})
				<span className={classNames("assignment-navigator-with-grouping-caret", {"is-closed": !isOpen})}>
					<Icon icon="arrow-down-chevron" size={10} />
				</span>
			</div>
			{isOpen && (
				<AssignmentNavigatorItemsList
					assignments={assignment}
					navigatorItemRef={navigatorItemRef}
					noItemsMessage={`No ${title}`}
				/>
			)}
		</div>
	)
}
